import React, { useState } from "react";
import axios from "../api/axios";
import { useToast } from "../context/ToastContext";

function Forgotpass() {
  const { notifyLoading, notifySuccess, notifyError } = useToast();

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const toastId = notifyLoading("Sending reset link...");
    setSubmitting(true);

    try {
      const response = await axios.post(`/api/user/forgot-password`, { email });

      // Jangan bergantung kepada user wujud / tak wujud
      const msg =
        response?.data?.message ||
        "If the email exists, a reset link has been sent.";

      notifySuccess(msg, { id: toastId });
      setEmail(""); // optional: clear input
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Error sending email, please try again.";
      notifyError(msg, { id: toastId });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="App">
      <div className="container mt-3">
        <div className="row justify-content-center text-center">
          <div className="col-12">
            <h1 className="my-4 header-title">FORGOT PASSWORD</h1>
          </div>

          <div className="row justify-content-center text-start mt-3">
            {/* Mobile col-12, desktop col-6 */}
            <div className="col-12 col-md-6">
              <div className="card">
                <div className="card-body">
                  <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                    Enter your email and we’ll send you a password reset link.
                  </p>

                  <form onSubmit={handleSubmit}>
                    <label className="form-label">Email address</label>
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={submitting}
                    />

                    <div className="d-grid mt-2">
                      <button
                        className="btn btn-sm btn-dark"
                        type="submit"
                        disabled={submitting}
                      >
                        {submitting ? "Sending..." : "Send Reset Link"}
                      </button>
                    </div>
                  </form>

                  <div className="text-muted mt-3" style={{ fontSize: 12 }}>
                    If you don’t receive the email, check spam/junk or try again in a minute.
                  </div>
                </div>
              </div>

              <div
                className="text-center mt-3"
                style={{ fontSize: 12, color: "#6c757d" }}
              >
                For security, we can’t confirm whether an email is registered.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forgotpass;
